<template>
	<div v-if="infos" class="item-list-container">
		<p class="title">{{ $t('itemsummarylist.title') }}</p>

		<div class="list-container" v-for="info in comInfos" :key="info.id">
			<div class="title">{{ `${info.buildingName} - ${info.floorName}` }}</div>
			
			<div class="panel-list-header narrow">
				<div class="panel-filler-icon" />
				<div class="panel-header-item pos" :class="{ mobile: isMobile }">
					{{ isMobile ? $t('itemsummarylist.header_pos_mobile') : $t('itemsummarylist.header_pos') }}
				</div>
				<div class="panel-header-item type">{{ $t('itemsummarylist.header_type') }}</div>
			</div>

			<!-- Item + flaws block -->
			<div v-for="item in info.items" :key="item.id">
				<!-- Item row -->
				<div class="panel-list no-hover narrow">
					<div class="panel-list-item special">
						<div
							class="fireprotection-icon"
							:class="getType(item.inventoryType)"
						></div>
					</div>
					<p class="panel-list-item pos" :class="{ mobile: isMobile }">
						{{ item.positionNumber }}
					</p>
					<div class="panel-list-item type">{{ item.name }}</div>
					<div class="panel-list-item flaw-total" v-if="getFlaws(item)">
						<i class="fas fa-exclamation-triangle"></i>
						{{ `: ${getFlaws(item)}` }}
					</div>
				</div>

				<!-- Flaws under item -->
				<div 
					class="panel-list no-hover narrow flaw-background"
					v-for="flaw in visibleFlaws(item)"
					:key="flaw.id"
				>
					<div class="panel-list-item special">
						<div class="fireprotection-icon flaw"></div>
					</div>
					<p class="panel-list-item pos" :class="{ mobile: isMobile }"></p>
					<div class="panel-list-item type">Brist</div>
					<div class="panel-list-item">
						{{ flaw.name }}
						{{ flaw.description ? ` - ${flaw.description}` : null }}
					</div>
				</div>
			</div>
		</div>

		<!-- Om inga kontrollerade finns -->
		<div class="panel-list no-hover" v-if="comInfos.length == 0">
			<p class="panel-list-item">{{ $t('itemsummarylist.no_controlled_items') }}</p>
		</div>
	</div>
</template>

<script>
import iconMixin from '@/mixins/iconMixin.js';
import { mapGetters } from 'vuex';

export default {
	mixins: [iconMixin],
	props: {
		infos: Array
	},
	computed: {
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('roundStore', ['round']),
		comInfos() {
			if (!Array.isArray(this.infos)) return [];

			let list = [];
			this.infos.forEach(info => {
				if (!info || !Array.isArray(info.roundHistoryItems)) return;

				let itemList = [];

				info.roundHistoryItems.forEach(item => {
					if (item && item.controlled) {
						itemList.push(item);
					}
				});

				if (itemList.length > 0) {
					itemList.sort((a, b) =>
						a.positionNumber > b.positionNumber
							? 1
							: a.positionNumber === b.positionNumber
								? a.id > b.id
									? 1
									: -1
								: -1
					);
					info.items = itemList;
					list.push(info);
				}
			});

			return list;
		}
	},
	methods: {
		getFlaws(item) {
			let total = 0;
			if (!item.flaws) return total;

			item.flaws.forEach(flaw => {
				if (item.continueWithoutAdding && !this.round.done && !flaw.done) {
					total++;
					return;
				}
				if (!flaw.created || flaw.created > this.round.created) {
					if (!this.round.done || flaw.created < this.round.done) {
						total++;
					}
				}
			});
			return total;
		},

		visibleFlaws(item) {
			if (!item.flaws) return [];
			return item.flaws.filter(flaw => {
				if (item.continueWithoutAdding && !this.round.done && !flaw.done) {
					return true;
				}
				if (!flaw.created || flaw.created > this.round.created) {
					return !this.round.done || flaw.created < this.round.done;
				}
				return false;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";
.item-list-container {
  margin-top: 1rem;
  p.title {
    font-size: 1.5rem;
  }
}
.panel-list-header.narrow,
.panel-list.narrow {
  margin-right: 0;
  margin-left: 0;
  width: 100%;
}
.list-container {
  &:not(:first-child) {
    margin-top: 0.8rem;
  }
  .title {
    font-size: 1.3rem;
    margin-bottom: 0.8rem;
  }
}
.panel-list-item.special {
  margin-right: 5px;
  max-width: 40px;
  position: relative;
}
.panel-list.narrow {
  .fireprotection-icon {
    top: -3px;
  }
}
.panel-list-item.flaw-total {
  margin-left: auto;
  max-width: 55px;
  i {
    color: $danger;
  }
}
.panel-list-item.type,
.panel-header-item.type {
  max-width: 250px;
}
.panel-list-item.pos,
.panel-header-item.pos {
  max-width: 80px;
  &.mobile {
    max-width: 40px;
  }
}
.fireprotection-icon {
  background-color: white;
  top: -7px;
  width: 30px;
  height: 30px;
  z-index: 2;
  position: absolute;
  background-size: contain;
  print-color-adjust: exact;
}

@media print {
  .item-list-container {
    break-inside: avoid;
  }
  .list-container:not(:first-of-type) {
    break-inside: avoid;
  }
}
.flaw-background {
	background-color: #ffe6e6 !important;
}
</style>
